<template>
  <div  v-bind:class="{hide: !showForm, 'd-flex justify-content-center': showForm}" class="w-100">
    <SoW />
  </div>
</template>

<script>
// @ is an alias to /src
import SoW from "@/components/GenerateSoW.vue";

export default {
  props: {
    msg: String,
    showForm: Boolean
  },
  name: "GenerateSoW",
  components: {
    SoW
  }
};
</script>
